import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import photo4 from './images/4.webp';
import photo5 from './images/5.webp';
import photo6 from './images/6.webp';
import photo7 from './images/10.webp';
import photo8 from './images/9.webp';
import photo9 from './images/12.webp';
import photo10 from './images/13.webp';
import photo11 from './images/16.webp';
import photo12 from './images/15.webp';
import photo13 from './images/17.webp';
import photo14 from './images/18.webp';
import photo15 from './images/20.webp';
import { Card, Button } from 'react-bootstrap';

const products = [
  { id: 1, name: 'Jointace Tablet 300 mg', price: 350, image: photo9 },
  { id: 2, name: 'Evion 400mg Strip Of 20 Capsule', price: 150, image: photo5 },
  { id: 3, name: 'Fytika Omega1000mg Bottle Of 60 Softgel Capsules', price: 200, image: photo7 },
  { id: 4, name: 'Depura Vitamin D3 60k Sugar Free Oral Solution 5ml', price: 35, image: photo4 },
  { id: 5, name: 'Hashmi Hard Rock Boost Energy Capsule 20', price: 90, image: photo8 },
  { id: 6, name: 'Complan Viemax Chocolate Flavour Refill 200gm', price: 220, image: photo6 },
  { id: 7, name: 'Sunhalt Gold Spf 50 Tube Of 60gm Hydrating Sunscreen', price: 45, image: photo10 },
  { id: 8, name: 'Skinnable Sunscreen Gel Spf 50+ 50 Gm', price: 140, image: photo11 },
  { id: 9, name: 'Acne Uv Spf 50 Gel 50gm', price: 240, image: photo12 },
  { id: 10, name: 'Pharmeasy Digital Thermometer Flexi Tip', price: 350, image: photo13 },
  { id: 11, name: 'Dr. Morepen Gluco One Bg 03 Glucometer Test Strips Box Of 50', price: 120, image: photo14 },
  { id: 12, name: 'Contour Plus Glucometer Test Strips Box Of 50', price: 320, image: photo15 },
];

const Medicines = () => {
  const navigate = useNavigate();

  const handleBuyNow = (id) => {
    const user = JSON.parse(localStorage.getItem('currentUser')) || JSON.parse(localStorage.getItem('loggedInUser'));
    if (user && user.email) {
      navigate(`/medicines/${id}`);
    }
     else {
    navigate(`/login`);   
    }
  };

  return (
    <Container className="mt-5">
      <h2 className="text-center mb-4">Medicines</h2>
      <Row>
        {products.map((product) => (
          <Col key={product.id} lg={3} md={4} sm={6} xs={12} className="mb-4">
            <Card className="h-100">
              <Card.Img
                variant="top"
                src={product.image}
                alt={product.name}
                style={{ height: '200px', objectFit: 'contain' }}
              />
              <Card.Body className="d-flex flex-column">
                <Card.Title>{product.name}</Card.Title>
                <Card.Text>₹{product.price}</Card.Text>
                <Button
                  className="mt-auto"
                  variant="primary"
                  onClick={() => handleBuyNow(product.id)}
                >
                  Buy Now
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Medicines;
